@if (initialized) {

  DUMMY!

}

